/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './LoadingIndicator.module.css';
import DotSpinner from '../DotSpinner';
import Lottie from 'react-lottie';

import loaderAnimation from 'animations/FWD_logo_loader_v3.json';

LoadingIndicator.propTypes = {
  isActive: PropTypes.bool
};

function LoadingIndicator(props) {
  const location = useLocation();
  const [isDotLoader, setIsDotLoader] = useState(true);
  const pathsIncludeLoaderAnimation = ['/direct/medical-care', '/direct/epf'];

  useEffect(() => {
    pathsIncludeLoaderAnimation.some(e => {
      return location.pathname.includes(e);
    })
      ? setIsDotLoader(false)
      : setIsDotLoader(true);
  }, [location, pathsIncludeLoaderAnimation]);

  const { isActive } = props;
  return (
    !!isActive && (
      <div className={styles.container}>
        <div className={styles.overlay}></div>
        {isDotLoader ? (
          <DotSpinner />
        ) : (
          <div className={styles.spinnerLogo}>
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: loaderAnimation
              }}
            />
          </div>
        )}
      </div>
    )
  );
}

export default LoadingIndicator;
